/**
 * Complete the Outfit — Lookbook JavaScript (Exact User Wireframe UI Edition)
 * Controls the horizontal row layout, variant selection (size & color),
 * default selected state, bundle discount comparison, and GoKwik cart integration.
 */
(function () {
  'use strict';

  // ─── Color Name → Hex Mapping ───────────────────────────────────────────
  var CTO_COLORS = {
    olivegreen:'#6B7B39', 'olive-green':'#6B7B39', olive:'#808000', green:'#008000',
    darkgreen:'#006400', 'dark-green':'#006400', forestgreen:'#228B22', militarygreen:'#4B5320',
    mintgreen:'#98FF98', bottlegreen:'#006A4E', emerald:'#50C878', sage:'#B2AC88',
    lime:'#32CD32', teal:'#008080', mint:'#3EB489', red:'#FF0000', maroon:'#800000',
    burgundy:'#800020', wine:'#722F37', rust:'#B7410E', brick:'#CB4154', pink:'#FFC0CB',
    hotpink:'#FF69B4', 'hot-pink':'#FF69B4', dustypink:'#D4A0A0', rose:'#FF007F',
    coral:'#FF6B6B', salmon:'#FA8072', peach:'#FFDAB9', magenta:'#FF00FF',
    blue:'#0000FF', navy:'#000080', navyblue:'#000080', 'navy-blue':'#000080',
    royalblue:'#4169E1', 'royal-blue':'#4169E1', skyblue:'#87CEEB', lightblue:'#ADD8E6',
    cobalt:'#0047AB', indigo:'#4B0082', denim:'#1560BD', steelblue:'#4682B4',
    aqua:'#00FFFF', brown:'#8B4513', tan:'#D2B48C', camel:'#C19A6B', khaki:'#C3B091',
    beige:'#F5F5DC', cream:'#FFFDD0', taupe:'#483C32', chocolate:'#7B3F00',
    coffeebrown:'#6F4E37', tobacco:'#A65E2E', sand:'#C2B280', terracotta:'#E2725B',
    white:'#FFFFFF', offwhite:'#FAF9F6', 'off-white':'#FAF9F6', ivory:'#FFFFF0',
    black:'#000000', charcoal:'#36454F', gray:'#808080', grey:'#808080',
    lightgray:'#D3D3D3', darkgray:'#A9A9A9', silver:'#C0C0C0', stone:'#928E85',
    yellow:'#FFFF00', gold:'#FFD700', mustard:'#FFDB58', orange:'#FF7F00',
    burntorange:'#CC5500', amber:'#FFBF00', saffron:'#F4C430', golden:'#FFD700',
    purple:'#800080', violet:'#EE82EE', lavender:'#B57EDC', lilac:'#C8A2C8',
    plum:'#DDA0DD', mauve:'#E0B0FF'
  };

  function resolveColor(name) {
    if (!name) return '#ccc';
    var key = name.toLowerCase().replace(/[\s\-_]+/g, '');
    if (CTO_COLORS[key]) return CTO_COLORS[key];
    for (var k in CTO_COLORS) {
      if (key.indexOf(k) !== -1 || k.indexOf(key) !== -1) return CTO_COLORS[k];
    }
    return '#ccc';
  }

  // ─── Format price in INR (e.g. ₹99,900) ─────────────────────────────────
  function formatPrice(paise) {
    var rupees = Math.round(paise / 100);
    return '₹' + rupees.toLocaleString('en-IN');
  }

  // ─── Init ───────────────────────────────────────────────────────────────
  function init() {
    var wrapper = document.querySelector('.cto-wrapper');
    if (!wrapper) return;

    var rows = wrapper.querySelectorAll('.cto-product-row, .cto-card');
    if (!rows.length) return;

    // Apply color swatches
    applyColorSwatches(wrapper);

    // Initial variant resolution for all rows
    rows.forEach(function (row) {
      updateItemVariant(row);
    });

    // ─── Click Row to Select / Unselect ───────────────────────────────────
    wrapper.addEventListener('click', function (e) {
      // 1. If clicked inside size pill or color swatch:
      if (e.target.closest('.cto-pill-label') || e.target.closest('.cto-swatch-label') ||
          e.target.closest('.cto-size-pill-item') || e.target.closest('.cto-color-dot-item')) {
        var parentRow = e.target.closest('.cto-product-row, .cto-card');
        if (parentRow && !parentRow.classList.contains('is-selected')) {
          parentRow.classList.add('is-selected');
          updateSummary(wrapper);
        }
        return; // Don't toggle off when clicking variant options
      }

      // 2. If clicked anywhere on the product row (image, title, price, background, badge):
      var row = e.target.closest('.cto-product-row, .cto-card');
      if (row) {
        row.classList.toggle('is-selected');
        updateSummary(wrapper);
      }
    });

    // ─── Variant Radio Change Listener ────────────────────────────────────
    wrapper.addEventListener('change', function (e) {
      if (e.target.classList.contains('cto-variant-input')) {
        var row = e.target.closest('.cto-product-row, .cto-card');
        if (row) {
          updateItemVariant(row);
          updateSummary(wrapper);
        }
      }
    });

    // Add to cart button handler
    var addBtn = wrapper.querySelector('#ctoAddToCartBtn');
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        addOutfitToCart(wrapper, addBtn);
      });
    }

    // Listen for main product variant changes on the page
    document.querySelectorAll('.variant-input').forEach(function (input) {
      input.addEventListener('change', function () {
        setTimeout(function () {
          updateSummary(wrapper);
        }, 50);
      });
    });

    // Initial summary calculation (default: all selected)
    updateSummary(wrapper);
  }

  // ─── Apply color swatches to color dots ─────────────────────────────────
  function applyColorSwatches(wrapper) {
    var colorDots = wrapper.querySelectorAll('.cto-swatch-dot, .cto-color-dot');
    colorDots.forEach(function (dot) {
      var colorHandle = dot.getAttribute('data-color') || '';
      var resolved = resolveColor(colorHandle);
      dot.style.setProperty('--cto-swatch-color', resolved);
    });
  }

  // ─── Update variant for a product row ───────────────────────────────────
  function updateItemVariant(row) {
    var variantsData = row.getAttribute('data-variants');
    if (!variantsData) return;

    var variants;
    try {
      variants = JSON.parse(variantsData);
    } catch (e) {
      return;
    }

    if (!variants || !variants.length) return;

    // Read selected options from radio inputs
    var selections = {};
    var inputs = row.querySelectorAll('.cto-variant-input:checked');
    inputs.forEach(function (input) {
      var optName = input.getAttribute('data-option-name');
      if (optName) {
        selections[optName] = input.value;
      }
    });

    // Update size availability based on selected color
    updateSizeAvailability(row, variants, selections);

    // Find the exact matching variant
    var matched = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var isMatch = true;
      for (var j = 0; j < v.options.length; j++) {
        var optName = v.option_names[j];
        if (selections[optName] !== undefined && selections[optName] !== v.options[j]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
        matched = v;
        break;
      }
    }

    // Fallback to first variant if no exact match
    if (!matched && variants.length > 0) {
      matched = variants[0];
    }

    if (matched) {
      row.setAttribute('data-selected-variant-id', matched.id);
      row.setAttribute('data-selected-price', matched.price);
      row.setAttribute('data-selected-compare', matched.compare_at_price || matched.price);

      // Update displayed price on the right
      var priceEl = row.querySelector('.cto-row-price, .cto-card-price');
      var compEl = row.querySelector('.cto-row-compare, .cto-card-compare-price');

      if (priceEl) {
        priceEl.textContent = matched.price_formatted;
      }
      if (compEl) {
        if (matched.compare_at_price && matched.compare_at_price > matched.price) {
          compEl.textContent = matched.compare_formatted;
          compEl.style.display = '';
        } else {
          compEl.style.display = 'none';
        }
      }

      // Update image if variant has featured image
      if (matched.featured_image && matched.featured_image.length > 5) {
        var imgEl = row.querySelector('.cto-img, .cto-card-img');
        if (imgEl) {
          imgEl.src = matched.featured_image;
        }
      }
    }
  }

  // ─── Update Size Availability based on chosen Color ─────────────────────
  function updateSizeAvailability(row, variants, selections) {
    var sizeInputs = row.querySelectorAll('.cto-size-radio');
    if (!sizeInputs.length) return;

    var anyVariantAvailable = variants.some(function (v) { return v.available; });

    sizeInputs.forEach(function (sizeInput) {
      var sizeVal = sizeInput.value;
      var sizeOptName = sizeInput.getAttribute('data-option-name');
      var pillLabel = sizeInput.closest('.cto-pill-label, .cto-size-pill-item');

      if (!anyVariantAvailable) {
        if (pillLabel) {
          pillLabel.classList.remove('is-disabled');
          pillLabel.title = sizeVal;
        }
        return;
      }

      var isAvailable = false;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;

        var matchesAllOthers = true;
        for (var j = 0; j < v.options.length; j++) {
          var oName = v.option_names[j];
          if (oName === sizeOptName) {
            if (v.options[j] !== sizeVal) {
              matchesAllOthers = false;
              break;
            }
          } else if (selections[oName] !== undefined && selections[oName] !== v.options[j]) {
            matchesAllOthers = false;
            break;
          }
        }

        if (matchesAllOthers) {
          isAvailable = true;
          break;
        }
      }

      if (pillLabel) {
        if (isAvailable) {
          pillLabel.classList.remove('is-disabled');
          pillLabel.title = sizeVal;
        } else {
          pillLabel.classList.add('is-disabled');
          pillLabel.title = sizeVal + ' (Out of stock in this color)';
        }
      }
    });
  }

  // ─── Get Main Product info (from page) ──────────────────────────────────
  function getMainProductInfo(wrapper) {
    var mainProductId = parseInt(wrapper.getAttribute('data-main-product-id') || '0', 10);
    var mainPrice = parseInt(wrapper.getAttribute('data-main-price') || '0', 10);
    var mainVariantId = parseInt(wrapper.getAttribute('data-main-variant-id') || '0', 10);
    var mainCompare = parseInt(wrapper.getAttribute('data-main-compare') || mainPrice, 10);

    if (window.productVariants && window.productVariants.length > 0) {
      var checkedOptions = {};
      document.querySelectorAll('.variant-input:checked').forEach(function (input) {
        checkedOptions[input.name] = input.value;
      });

      for (var i = 0; i < window.productVariants.length; i++) {
        var v = window.productVariants[i];
        var match = true;
        for (var j = 0; j < v.options.length; j++) {
          if (v.options[j] !== checkedOptions[v.option_names[j]]) {
            match = false;
            break;
          }
        }
        if (match) {
          return {
            id: v.id,
            productId: mainProductId,
            price: v.price,
            compare_at_price: v.compare_at_price || v.price
          };
        }
      }
    }

    return {
      id: mainVariantId,
      productId: mainProductId,
      price: mainPrice,
      compare_at_price: mainCompare
    };
  }

  // ─── Update Summary & Price Difference ──────────────────────────────────
  function updateSummary(wrapper) {
    var rows = wrapper.querySelectorAll('.cto-product-row, .cto-card');
    var totalRowsCount = rows.length;
    var mainInfo = getMainProductInfo(wrapper);

    var rawTotalSale = 0;
    var selectedCount = 0;

    rows.forEach(function (row) {
      var isSelected = row.classList.contains('is-selected');
      if (!isSelected) return;

      selectedCount++;

      var selectedPrice = parseInt(row.getAttribute('data-selected-price') || '0', 10);
      rawTotalSale += selectedPrice;
    });

    // Complete Outfit Price = Main Product Price
    var completeOutfitPrice = (mainInfo && mainInfo.price > 0) ? mainInfo.price : rawTotalSale;

    // Difference between Buy Separately Total (3 items) and Complete Outfit Price
    var diff = rawTotalSale - completeOutfitPrice;

    // ── Update Count in Labels ──
    wrapper.querySelectorAll('.cto-item-count, .cto-btn-count').forEach(function (el) {
      el.textContent = selectedCount;
    });

    // ── Update Comparison Table Elements ──
    var singleLabel = wrapper.querySelector('.cto-row-single .cto-compare-label');
    var singlePriceEl = wrapper.querySelector('.cto-price-single');
    var bundleRow = wrapper.querySelector('.cto-row-bundle');
    var bundleLabel = wrapper.querySelector('.cto-row-bundle .cto-compare-label');
    var bundlePriceEl = wrapper.querySelector('.cto-price-bundle');
    var savingsBanner = wrapper.querySelector('#ctoSavingsBanner');
    var btnTextEl = wrapper.querySelector('.cto-btn-text');
    var addBtn = wrapper.querySelector('#ctoAddToCartBtn');

    var isFullOutfit = (selectedCount === totalRowsCount && totalRowsCount > 0);

    if (isFullOutfit) {
      // ALL OUTFIT ITEMS SELECTED
      if (singleLabel) {
        singleLabel.innerHTML = '<span class="cto-dot cto-dot-grey"></span> Buy Separately (' + selectedCount + ' Items):';
      }
      if (singlePriceEl) {
        singlePriceEl.textContent = formatPrice(rawTotalSale);
        singlePriceEl.style.textDecoration = 'none';
        singlePriceEl.style.display = '';
      }

      if (bundleRow) bundleRow.style.display = '';
      if (bundleLabel) {
        bundleLabel.innerHTML = '<span class="cto-dot cto-dot-green"></span> Complete Outfit Price:';
      }
      if (bundlePriceEl) {
        bundlePriceEl.textContent = formatPrice(completeOutfitPrice);
      }

      // Difference / Savings Banner
      if (savingsBanner) {
        if (diff > 0) {
          savingsBanner.innerHTML = '<span class="cto-savings-icon">🎉</span> <span class="cto-savings-text">Complete Outfit Savings: <strong>Save ' + formatPrice(diff) + '</strong></span>';
        } else if (diff < 0) {
          savingsBanner.innerHTML = '<span class="cto-savings-icon">✨</span> <span class="cto-savings-text">Price Difference: <strong>' + formatPrice(Math.abs(diff)) + '</strong></span>';
        } else {
          savingsBanner.innerHTML = '<span class="cto-savings-icon">✨</span> <span class="cto-savings-text">Best Deal on Complete Outfit!</span>';
        }
        savingsBanner.style.display = '';
      }

      if (btnTextEl) {
        btnTextEl.innerHTML = 'Add to Cart (' + selectedCount + ' Items) • ' + formatPrice(rawTotalSale);
      }
      if (addBtn) addBtn.disabled = false;

    } else if (selectedCount > 0) {
      // PARTIAL ITEMS SELECTED
      if (singleLabel) {
        singleLabel.innerHTML = '<span class="cto-dot cto-dot-grey"></span> Selected Items (' + selectedCount + ' Items):';
      }
      if (singlePriceEl) {
        singlePriceEl.textContent = formatPrice(rawTotalSale);
        singlePriceEl.style.textDecoration = 'none';
        singlePriceEl.style.display = '';
      }

      if (bundleRow) {
        bundleRow.style.display = '';
        if (bundleLabel) {
          bundleLabel.innerHTML = '<span class="cto-dot cto-dot-green"></span> Complete Outfit Price:';
        }
        if (bundlePriceEl) {
          bundlePriceEl.textContent = formatPrice(completeOutfitPrice);
        }
      }

      if (savingsBanner) {
        savingsBanner.innerHTML = '<span class="cto-savings-icon">💡</span> <span class="cto-savings-text">Select all ' + totalRowsCount + ' items to get Complete Outfit deal!</span>';
        savingsBanner.style.display = '';
      }

      if (btnTextEl) {
        btnTextEl.innerHTML = 'Add to Cart (' + selectedCount + ' Item' + (selectedCount > 1 ? 's' : '') + ') • ' + formatPrice(rawTotalSale);
      }
      if (addBtn) addBtn.disabled = false;

    } else {
      // ZERO ITEMS SELECTED
      if (singleLabel) {
        singleLabel.innerHTML = '<span class="cto-dot cto-dot-grey"></span> Selected Items (0):';
      }
      if (singlePriceEl) {
        singlePriceEl.textContent = '₹0';
        singlePriceEl.style.textDecoration = 'none';
      }

      if (bundleRow) {
        bundleRow.style.display = '';
        if (bundleLabel) {
          bundleLabel.innerHTML = '<span class="cto-dot cto-dot-green"></span> Complete Outfit Price:';
        }
        if (bundlePriceEl) {
          bundlePriceEl.textContent = formatPrice(completeOutfitPrice);
        }
      }

      if (savingsBanner) {
        savingsBanner.innerHTML = '<span class="cto-savings-icon">👉</span> <span class="cto-savings-text">Click on any item above to add to your outfit!</span>';
        savingsBanner.style.display = '';
      }

      if (btnTextEl) {
        btnTextEl.textContent = 'Select Items to Add';
      }
      if (addBtn) addBtn.disabled = true;
    }
  }

  // ─── Add Outfit Items to Cart ───────────────────────────────────────────
  function addOutfitToCart(wrapper, btn) {
    var rows = wrapper.querySelectorAll('.cto-product-row.is-selected, .cto-card.is-selected');
    var cartItems = [];

    if (rows.length === 0) {
      alert('Please select at least one item.');
      return;
    }

    // Add selected items to cart at Buy Separately price
    rows.forEach(function (row) {
      var variantId = parseInt(row.getAttribute('data-selected-variant-id'), 10);
      if (variantId) {
        cartItems.push({
          id: variantId,
          quantity: 1,
          properties: {
            '_bundle': 'Complete the Outfit',
            'Outfit': 'Buy Separately'
          }
        });
      }
    });

    if (cartItems.length === 0) {
      alert('Please select at least one item.');
      return;
    }

    // Disable button and show loading text
    btn.disabled = true;
    var originalHtml = btn.innerHTML;
    btn.innerHTML = '<span class="cto-btn-text">Adding items to cart...</span>';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: cartItems })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function (data) {
        // Refresh cart count & dispatch theme events
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('.as-cart-count').forEach(function (el) {
              el.textContent = cart.item_count;
              el.style.display = cart.item_count > 0 ? 'flex' : 'none';
            });
            document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart } }));
            document.dispatchEvent(new CustomEvent('cart:add', { detail: { resource: data } }));
          })
          .catch(function () {});

        // Trigger GoKwik Checkout if available
        var merchant = window.merchantInfo || (typeof merchantInfo !== 'undefined' ? merchantInfo : null);
        if (window.gokwikSdk && typeof window.gokwikSdk.initCheckout === 'function' && merchant) {
          window.gokwikSdk.initCheckout(merchant);
          btn.disabled = false;
          btn.innerHTML = originalHtml;
        } else {
          // Open cart drawer if available
          if (typeof window.refreshCartDrawer === 'function') {
            window.refreshCartDrawer();
          }
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
            btn.disabled = false;
            btn.innerHTML = originalHtml;
          } else {
            // Fallback: redirect to cart
            window.location.href = '/cart';
          }
        }
      })
      .catch(function (err) {
        console.error('Lookbook Cart Add Error:', err);
        btn.disabled = false;
        btn.innerHTML = originalHtml;
        alert('Something went wrong while adding items to cart. Please try again.');
      });
  }

  // ─── DOM Ready ──────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
